import { Box, BoxProps } from "@chakra-ui/react";

export function MobileOnly(props: BoxProps) {
  return <Box display={["block", null, "none"]} {...props} />;
}
